import { useContext, useEffect, useState } from "react";
import ImportContactsRoundedIcon from "@mui/icons-material/ImportContactsRounded";
import StepperComponent from "../../../components/stepper/stepper";
import ApplicationUpsertForm, {
  IAddEditProviderModel,
} from "../application-upsert-form";
import {
  INewApplicationModel
} from "../applications-model";
import pubSub, { EVENTS } from "../../../config/pubSub";
import ApplicationService from "../applications-service";
import { AppConfig } from "../../../context/context";
import { ApplicationsContext } from "../applications-context";
import { useTranslation } from "react-i18next";
import { BorderedBox } from "../../../components/bordered-box/bordered-box";
import { useService }from "../applications-service";

type IProps = {
  handleClose: () => void;
  handleDone: () => void;
  model: IAddEditProviderModel;
  handleModelChange: (updatedModel: any) => void;
};

function getSteps() {
  return ["Name & License"];
}

function GetStepContent(
  model: IAddEditProviderModel,
  handleModelChange: (updatedModel: any) => void,
) {
  const { t } = useTranslation();
  return {
    0: (
      <BorderedBox>
        <ApplicationUpsertForm model={model} handleModelChange={handleModelChange}/>
      </BorderedBox>
    ),
  };
}

const getIcons = () => {
  return {
    0: <ImportContactsRoundedIcon />,
  };
};

const EditCustomerComponent = (props: IProps) => {
  const icons = getIcons();
  const steps = getSteps();
  const { model, handleModelChange } = props;
  const [http, setHttp] = useState<any>(null);
  const { config } = useContext(AppConfig);
  const { t } = useTranslation();
  const { selectedApp } = useContext(ApplicationsContext);
  const { appService } = useService();

  const stepsContent = GetStepContent(model, handleModelChange);

  const handleCancel = () => {
    props.handleClose();
  };

  const HandleDone = async () => {
    const newApplicationModel: INewApplicationModel = {
      name: model[0].name,
    };

     try {
      await appService.patchApplication(config.tenantId, selectedApp, newApplicationModel);
      props.handleDone();
    } catch (error: any) {
      if (error.response) {
        switch (+error.response.status) {
          case 409:
            pubSub.publish(EVENTS.PP_ERROR_ORGANIZATION_DUP, error.response);
            break;
          default:
            pubSub.publish(EVENTS.ERROR, "common_error_msg");
        }
      } else {
        pubSub.publish(EVENTS.ERROR, "common_error_msg");
      }
    }
  };

  return (
    <StepperComponent
      icons={icons}
      steps={steps}
      isValid={model.isValid}
      isSameValue={model.isSameValue}
      stepsContent={stepsContent}
      handleCancel={handleCancel}
      handleDone={HandleDone}
      isEdit={true}
    />
  );
};

export default EditCustomerComponent;
